import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboardCable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconKeyboardCable"><Path d="M5.5 8.5V4.5H18.5V2.5M9.75 17.25H14.25M9.5 17.25H14.5M1.5 8.5H22.5V21.5H1.5V8.5ZM6 12.5H5.5V13H6V12.5ZM10 12.5H9.5V13H10V12.5ZM14.5 12.5H14V13H14.5V12.5ZM18.5 12.5H18V13H18.5V12.5ZM18.5 17H18V17.5H18.5V17ZM6 17H5.5V17.5H6V17Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconKeyboardCable;
